import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, OnDestroy, Input } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';

import { DomManipulateService } from '@app/modules/core/services/dom-manipulate.service';

@Component({
  selector: 'app-loading-green',
  templateUrl: './loading-green.component.html',
  styleUrls: ['./loading-green.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class LoadingGreenComponent implements OnInit, OnDestroy {

  @Input() isMobile: boolean;
  @Input() maxWidth: string = '200px';
  @Input() maxHeight: string = '200px';
  @Input() marginLeft: string = '35px';
  @Input() manipulateDOM: boolean = true;
  @Input() classType: string = '';
  
  public options: AnimationOptions = { path: '/assets/libs/ngx-lottie/loading.json' };
  public styles: Partial<CSSStyleDeclaration> = {};
  
  constructor(private domManipulateService: DomManipulateService) { }

  ngOnInit(): void {
    this.styles = { maxWidth: this.maxWidth, maxHeight: this.maxHeight, marginLeft: this.marginLeft };
    if (this.isMobile) this.disabledScoll();
  }

  ngOnDestroy(): void {
    if (this.isMobile) this.enabledScoll();
  }

  private disabledScoll(): void {
    if (this.manipulateDOM) this.domManipulateService.setBodyScroll(false);
  }

  private enabledScoll(): void {
    if (this.manipulateDOM) this.domManipulateService.setBodyScroll(true);
  }

}
